import { CellSpacing } from '@cbhq/cds-web/cells/Cell';

// Mobile Spacing
export const MOBILE_WEB_SPACING_VERTICAL = 3;
export const MOBILE_WEB_SPACING_HORIZONTAL = 3;

// Gap between bottom-pinned content (primary buttons, legal text, footers) and
// the bottom of the screen on mobile — 32px (CDS token 4). Single standard for
// every signed-out sign-in/sign-up surface (IDFE-3959). Measured from the
// webview's bottom edge: the native host owns the home-indicator / nav-bar inset.
export const MOBILE_WEB_PINNED_BOTTOM_SPACING = 4;

// Mobile Gap
export const MOBILE_WEB_HEADER_GAP = 1;
export const MOBILE_WEB_CONTENT_GAP = 3;
export const MOBILE_WEB_FOOTER_GAP = 2;

// Desktop Spacing
export const DESKTOP_SPACING_VERTICAL = 4;
export const DESKTOP_SPACING_HORIZONTAL = 4;

// 448px identity screen shells — 24px gutters (CDS token 3), 400px of content.
export const DESKTOP_CONTENT_SPACING_HORIZONTAL = 3;

// Desktop Gap
export const DESKTOP_WEB_HEADER_GAP = 1;
export const DESKTOP_WEB_CONTENT_GAP = 3;
export const DESKTOP_WEB_FOOTER_GAP = 2;

export const CONTENT_CELL_OUTER_SPACING = { padding: 0 } as CellSpacing;
